import { trackPageLoad } from './aep_analytics_util.js';
import { enableConsentCheck } from './adobe_privacy.js';
import { initLinksWithPostLoginAction } from './authentication_util.js';
import { loadFonts, init as initDynamicKit } from './DynamicKit.js';
import { init as initIms } from './imslib.js';
import { initFontLoadingFailedListener } from './font_loading_failed_listener.js';
import { initMauEventListener } from './mau_event.js';
import { registerEventHandlers as registerPageLoadDialogEventHandlers } from '../components/mixins/PageLoadDialog.ts';
import SitewideHeaderController from '../controllers/sitewide_header.js';
import { addLinkPaywallClasses } from './link_paywall_class.js';
import { initSUSILight } from './susi_light_util.js';
import UrlService from './url_service.js';

const PAYWALL_DEBOUNCE_TIME = 150;

/**
 * Global setup that is applicable everywhere including, backend and legacy-backend pages.
 */
export function setupGlobals() {
  UrlService.removeSearchParam('logged_out');

  initDynamicKit();
  loadFonts();
  initIms();
}

/**
 * Global setup that is only applicable to the customer-facing side of the site.
 */
export function setupClientGlobals() {
  if (window.location.pathname.includes('backend')) {
    return;
  }

  enableConsentCheck();
  const sitewideHeaderController = new SitewideHeaderController();
  sitewideHeaderController.init();
  initSUSILight();
  initLinksWithPostLoginAction();

  registerPageLoadDialogEventHandlers();
  initFontLoadingFailedListener();
  initMauEventListener();

  trackPageLoad();

  // we only run the paywall class mutation if the user is a visitor and the require login flag is enabled
  if (!document.querySelector('#paywall-config')) {
    return;
  }

  let paywallDebounceTimer;
  const mutationObserver = new MutationObserver((mutations) => {
    if (!mutations.some(m => [...m.addedNodes].some(n => n.nodeType === Node.ELEMENT_NODE))) {
      return;
    }
    clearTimeout(paywallDebounceTimer);
    paywallDebounceTimer = setTimeout(addLinkPaywallClasses, PAYWALL_DEBOUNCE_TIME);
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}
